import axios from 'axios';

export default async function getPost({
  accessToken,
  postId,
}) {
  const requestOptions = {
    headers: {
      'access-token': accessToken,
    },
  };

  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_GOOGLE_API_URL}/posts/get-one/${postId}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    return err.response;
  }
}
